<template>
	<div class="delete_person">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">设置识别记录的缓存上限</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			无网络时，识别记录会存在本地，有网络时在发送给服务器。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">void __stdcall SKFaceSetUploadBufferSpace(int nMBCount);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">nMBCount：缓存大小，单位MB，1MB为20条，默认400条</p>
        
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	无
		</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">SKFaceSetUploadBufferSpace(20);</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceLive-Windows','本地接口','设置识别记录的缓存上限'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.delete_person{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacelivewindows/localface/setUpperLimit.vue